/**
 * How long a child has been at it, and when Sneakers suggests a break
 * ([Gamification](../../../docs/GAMIFICATION.md#session-care),
 * [D-160](../../../docs/DECISIONS.md#d-160), mockup 31).
 *
 * A *sitting* is answers with no long pause between them. It is worked out
 * from when answers happened, which the app records anyway, so there is no
 * timer running on the device and nothing new stored about the child.
 *
 * **Always only a suggestion.** Nothing here can stop a lesson: the answer is
 * a number of minutes and whether to say something, and the screen that says
 * it has a button that carries on.
 */
/** A pause this long ends a sitting: a child who went for a snack came back fresh. */
export const SITTING_GAP_MINUTES = 15;
/** When Sneakers suggests a break: once, then again more warmly. */
export const BREAK_AFTER_MINUTES = [25, 45];
const MINUTE = 60_000;
/**
 * When the sitting going on now began, or null if there is none — no answers,
 * or the last one was longer ago than the gap.
 *
 * `times` may come in any order.
 */
export function sittingStart(times, now, gapMinutes = SITTING_GAP_MINUTES) {
    const newestFirst = [...times]
        .filter((at) => at.getTime() <= now.getTime())
        .sort((a, b) => b.getTime() - a.getTime());
    const [newest] = newestFirst;
    if (newest === undefined)
        return null;
    if (now.getTime() - newest.getTime() > gapMinutes * MINUTE)
        return null;
    let start = newest;
    for (const at of newestFirst.slice(1)) {
        if (start.getTime() - at.getTime() > gapMinutes * MINUTE)
            break;
        start = at;
    }
    return start;
}
/** Whole minutes from the start of the sitting to now. */
export const minutesSince = (start, now) => Math.max(0, Math.floor((now.getTime() - start.getTime()) / MINUTE));
/**
 * The break to suggest now, or null.
 *
 * The latest threshold passed, if it is later than the one already shown in
 * this sitting — so each is said once, and a child who carried on past 25 is
 * not asked again until 45.
 */
export function breakDue(minutes, alreadyShown) {
    const passed = BREAK_AFTER_MINUTES.filter((at) => minutes >= at);
    const latest = passed.at(-1);
    if (latest === undefined)
        return null;
    return alreadyShown !== null && alreadyShown >= latest ? null : latest;
}
//# sourceMappingURL=sitting.js.map